import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as constants from "../const";
import { showModalAction, getWorkdayAction } from "../actions/index";
import moment from "moment";
import './manuallyUpdate.css';

class HOSLogsWorkDay extends React.Component {
  constructor(props) {
      super(props);
      this.state = {
          showPopup: false
      };
    
  }
  // show claimed employee details
  showModal(modalObj) {
    
    var workday = this.props.workday;
    this.props.onShowModal(modalObj.modalName);
    var route = localStorage.getItem("route");
    var category = route;
    var workdayDate = moment(modalObj.workdayDate, 'MM/DD/YYYY')
    workdayDate = workdayDate.format('YYYYMMDD');
    let role = this.props.role;
    let url = constants.actionUrls.HOS_LOG_DETAILS;
    url = url + "/" + role + "/" + modalObj.workdayId + "/" + modalObj.certifyStatus
    + "/" + modalObj.empId + "/" + workdayDate + "/" + modalObj.dutyActivityStatus;
    if(workday.isPayDetail){
        url = url+ "/" + workday.isPayDetail + "/" + workday.RestBreakNo
    } 
    this.props.getWorkday(url);
  }
  
  rendeStatusForHosLog() {
    var workday = this.props.workday,
        certifyTxt = workday.dutyActivityStatus == 'N' ? 'OFF' : "Not Certified";
    var colorCode = function(){
        if(workday.dutyActivityStatus == 'N'){
            return constants.COLORS.Black;
        } else if(workday.wdy_certify_status == constants.UNCERTIFIED){
            return constants.COLORS.Green;
        }
    }
    var modalObj = {
        workdayId:workday.id,
        certifyStatus:workday.wdy_certify_status,
        empId:workday.demp_display_Id,
        workdayDate:workday.wdy_date,
        modalName:constants.hosModals.Certify_Modal,
        dutyActivityStatus:workday.dutyActivityStatus
    }
    if (workday.wdy_certify_status == constants.UNCERTIFIED) {
        return (
            <div>
                <a className={"" + (workday.dutyActivityStatus == "N" ? "underline" : "")} style={{"color": colorCode()}}>
                    {certifyTxt }
                </a>
            </div>
        );
    }
    else {
        modalObj.modalName = constants.hosModals.Certify_Modal;
        return (
            <div>
                <a>
                {workday.IsAmendment == '1' ? 'Amendment-' + workday.AmendmentId +' ' : workday.Created_By == 'system' ? 'Certified-s' : 'Certified'}
                </a>
            </div>
        )
    }
}
  render() {
    if (this.props.workday) {
      var workday = this.props.workday;    
      var full_name = workday.emp_full_name.split(" "),
      first_name = full_name[full_name.length-1],
      last_name = workday.emp_full_name.replace(first_name,'');
      var modalObj = {
        workdayId:workday.id,
        certifyStatus:workday.wdy_certify_status,
        empId:workday.demp_display_Id,
        workdayDate:workday.wdy_date,
        modalName: constants.hosModals.Certify_Modal,
        dutyActivityStatus:workday.dutyActivityStatus
      }
      let status = this.props.statusQueryParams?this.props.statusQueryParams:false;
      let greater12 = this.props.greater12 ? true : false;
      
      let hos = workday.isPayDetail == '1' ? workday.wdy_time_hos_Calc : workday.wdy_working_time_hos_adjust;
      hos = hos && hos.toLowerCase().lastIndexOf('m') <= 0?hos.trim().toUpperCase() + 'M':hos;
      return (
        <tr>
          <td data-title="Employee ID" className="text-center">
            <a className="popUpLink" onClick={() =>
                this.showModal(modalObj)}>
                {this.props.workday.demp_display_Id}
            </a>
          </td>
          <td data-title="First Name" className="text-center"> {first_name} </td>
          <td data-title="Last Name" className="text-center"> {last_name} </td>
          <td data-title="Service Date" className="text-center"> {workday.wdy_date} </td>
          <td data-title="Type" className="text-center"> {workday.job_type} </td>
          {!greater12 ? <td data-title="14 Day Cycle" className="text-center hidden"> {workday.wdy_14dayValue} </td> : null}          
          {greater12 || status =='C' ? <td data-title="Total HOS" className="text-center"> {hos} </td> : null}
          <td  data-title="Date" className="text-center">{workday.wdy_certify_status == constants.CERTIFIED ? workday.wdy_certify_date : ''} </td>
          <td  data-title="Date" className="text-center">
          {
            this.rendeStatusForHosLog()
          } 
          </td>
        </tr>
      );
    }
  }
}

function mapStateToProps(state) {
  return {
    workdays: state.workdays.workdays,
    pageNum: state.workdays.pageNum
  };
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      onShowModal: showModalAction,
      getWorkday: getWorkdayAction
    },
    dispatch
  );
}

export default connect(mapStateToProps, matchDispatchToProps)(
  HOSLogsWorkDay
);
